<div class="modal-header">
  <h4 class="modal-title pull-left">{{'GLOBAL.CONF_ANALYSE' | translate}}</h4>
  <button type="button" class="close pull-right" aria-label="Close" (click)="showModalCancel()" title="{{'GLOBAL.FERMER' | translate}}">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <form id="myForm" (ngSubmit)="onSubmit()">
    <div class="form-group">
      <label for="nomConfig">{{'GLOBAL.NOM' | translate}}</label>
      <input id="nomConfig" type="text" [(ngModel)]="config.referentielDonneeAnalyse.nom" name="nomConfig" class="form-control" placeholder="{{'GLOBAL.NOM' | translate}}" disabled />
    </div>
    <div class="row">
      <div class="col-lg-6">
        <div class="form-group">
          <label for="type">{{'CONFIGURATION_DONNEES.TYPE' | translate}}</label>
          <input id="type" type="text" [(ngModel)]="config.referentielDonneeAnalyse.nomTypeReferentiel" name="type" class="form-control" placeholder="{{'CONFIGURATION_DONNEES.TYPE' | translate}}" disabled />
        </div>
      </div>
      <div class="col-lg-6">
        <div class="form-group">
          <label for="unite">{{'CONFIGURATION_DONNEES.UNITE' | translate}}</label>
          <input id="unite" type="text" [(ngModel)]="config.referentielDonneeAnalyse.nomUniteReferentiel" name="unite" class="form-control" placeholder="{{'CONFIGURATION_DONNEES.UNITE' | translate}}" disabled />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <label for="unite">{{'CONFIGURATION_DONNEES.DONNEE_PROJET' | translate}}</label>
        <ng-select [items]="tabModeSaisieProjet"
          [multiple]="false"
          [closeOnSelect]="true"
          [searchable]="false"
          bindLabel="nom"
          bindValue="val"
          placeholder="{{'CONFIGURATION_DONNEES.DONNEE_PROJET' | translate}}"
          name="selectModeSaisie"
          [clearable]="false"
          id="selectModeSaisie"
          [(ngModel)]="config.modeSaisieDonneeProjet"
          (change)="onChangeModeSaisie($event)">
        </ng-select>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-6">
        <div class="form-group">
          <label for="saisieUtil">{{'CONFIGURATION_DONNEES.IS_ENABLED' | translate}}</label>
          <button type="button" id="saisieUtil" name="saisieUtil" btnCheckbox class="toggle-btn" [ngClass]="config.isEnabled === true ? 'btn-success':'btn-danger'"
            [(ngModel)]="config.isEnabled" (click)="checkIsEnabled()">
            {{config.isEnabled ? ('GLOBAL.OUI' | translate) : ('GLOBAL.NON' | translate)}}
          </button>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="form-access-permission">
          <label class="label-access-permission" for="saisieClient">{{accessPermissionArray[config.accessPermission] | translate}}</label>
          <div class="access-permission">
            <form type="button" class="access-permission-form" id="saisieClient" action=""  [ngClass]="{'red': config.accessPermission == 0, 'blue': config.accessPermission == 1, 'green': config.accessPermission == 2,'disabled':isAccessPermissionDisabled}"  >
              <span class="access-permission-item"><input type="radio" [value]="0" [(ngModel)]="config.accessPermission" name="accessPermission" #none id="none" >            <div class="icon" (click)="config.accessPermission = 0"  ><img src="../../../assets/icon/user-block.png"    alt="" [ngClass]="{'a-red': config.accessPermission == 0}" /></div></span>
              <span class="access-permission-item"><input type="radio" [value]="1" [(ngModel)]="config.accessPermission" name="accessPermission" #read id="read" >            <div class="icon-small" (click)="config.accessPermission = 1"><img src="../../../assets/icon/user-read.svg" alt="" [ngClass]="{'a-blue': config.accessPermission == 1}" /></div></span>
              <span class="access-permission-item"><input type="radio" [value]="2" [(ngModel)]="config.accessPermission" name="accessPermission" #readwrite id="read-write" > <div class="icon" (click)="config.accessPermission = 2"><img src="../../../assets/icon/user-readwrite.png"  alt="" [ngClass]="{'a-green': config.accessPermission == 2}" /></div></span>
            </form>
          </div>
        </div>
      </div>
    </div>
    @if (config.referentielDonneeAnalyse.nomTypeReferentiel == 'number') {
      <div class="row">
        <div class="col-lg-6">
          <div class="form-group">
            <label for="valeurMin">{{'CONFIGURATION_DONNEES.VALEUR_MIN' | translate}}</label>
            <input type="number" id="valeurMin" name="valeurMin" class="form-control" [(ngModel)]="config.valeurMin" />
            @if (valeurMinVide) {
              <div class="custom-alert custom-alert-sm">{{'GLOBAL.CHAMP_OBLIGATOIRE' | translate }}</div>
            }
          </div>
        </div>
        <div class="col-lg-6">
          <div class="form-group">
            <label for="valeurMax">{{'CONFIGURATION_DONNEES.VALEUR_MAX' | translate}}</label>
            <input type="number" id="valeurMax" name="valeurMax" class="form-control" [(ngModel)]="config.valeurMax" />
            @if (valeurMaxVide) {
              <div class="custom-alert custom-alert-sm">{{'GLOBAL.CHAMP_OBLIGATOIRE' | translate }}</div>
            }
          </div>
        </div>
        @if (valeursNonCoherentes) {
          <div class="custom-alert custom-alert-sm col-lg-12">{{'CONFIGURATION_DONNEES.ERREUR_VALEUR_MIN_MAX' | translate }}</div>
        }
      </div>
      <div class="row">
        <div class="col-lg-6">
          <div class="form-group">
            <label for="valeurNominal">{{'CONFIGURATION_DONNEES.VALEUR_NOMINAL' | translate}}</label>
            <input type="number" id="valeurNominal" name="valeurNominal" class="form-control" [(ngModel)]="config.valeurNominal" (change)="valeurNominalCheck()" />
            @if (valeurNomVide) {
              <div class="custom-alert custom-alert-sm">{{'GLOBAL.CHAMP_OBLIGATOIRE' | translate }}</div>
            }
          </div>
        </div>
        @if (erreurValeurNominal) {
          <div class="custom-alert custom-alert-sm col-lg-12">{{'CONFIGURATION_DONNEES.ERREUR_VALEUR_NOMINAL' | translate }}</div>
        }
      </div>
    }
    @if (erreurApi) {
      <div class="custom-alert custom-alert-sm">{{'GLOBAL.ERREUR_MAJ_API' | translate }}</div>
    }
    <div class="btn-toolbar justify-content-between">
      <div class="btn-group" role="group">
        <button type="submit" class="btn btn-outline-success" style="margin-right:10px;">{{'GLOBAL.VALIDER' | translate}}</button>
      </div>
      <div class="btn-group" role="group">
        <button type="button" class="btn btn-secondary" (click)="showModalCancel()">{{'GLOBAL.FERMER' | translate}}</button>
      </div>
    </div>
  </form>
</div>

<div bsModal #modalConfirmCancel="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="dialog-child-name" [config]="{backdrop: 'static'}">
  <div class="modal-dialog modal-sm">
    <div class="modal-content">
      <div class="custom-overlay"></div>
      <div class="modal-body text-center">
        <p>{{'GLOBAL.CONFIRMATION_ANNULATION' | translate}}</p>
        <button type="button" class="btn btn-primary" (click)="annulModif()">{{'GLOBAL.OUI' | translate}}</button>
        <button type="button" class="btn btn-secondary" (click)="modalConfirmCancel.hide()" style="margin-left: 20px;">{{'GLOBAL.NON' | translate}}</button>
      </div>
    </div>
  </div>
</div>
